import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface RelatedOrder {
  id: string;
  orderNumber: string;
  date: string;
  status: string;
  total: number;
  itemCount: number;
  thumbnail: string;
  alt: string;
}

interface RelatedOrdersProps {
  orders: RelatedOrder[];
}

const RelatedOrders = ({ orders }: RelatedOrdersProps) => {
  return (
    <div className="bg-card rounded-lg shadow-elevation-md p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading text-xl font-semibold text-foreground">Recent Orders</h2>
        <Link
          href="/user-profile"
          className="text-sm text-primary font-medium hover:underline flex items-center gap-1"
        >
          <span>View All</span>
          <Icon name="ChevronRightIcon" size={16} />
        </Link>
      </div>

      <div className="space-y-3">
        {orders.map((order) => (
          <Link
            key={order.id}
            href={`/order-tracking?id=${order.orderNumber}`}
            className="flex items-center gap-4 p-4 bg-muted rounded-lg transition-smooth hover:bg-border hover:shadow-elevation-sm"
          >
            <div className="w-16 h-16 rounded-md overflow-hidden flex-shrink-0">
              <AppImage
                src={order.thumbnail}
                alt={order.alt}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between mb-1">
                <p className="font-data font-medium text-sm text-foreground">
                  #{order.orderNumber}
                </p>
                <span className="text-xs font-caption px-2 py-1 bg-primary/10 text-primary rounded">
                  {order.status}
                </span>
              </div>
              <p className="text-xs text-muted-foreground mb-1">{order.date}</p>
              <div className="flex items-center justify-between">
                <p className="text-xs text-muted-foreground">{order.itemCount} items</p>
                <p className="font-data font-semibold text-sm text-primary">
                  ₹{order.total.toFixed(2)}
                </p>
              </div>
            </div>
            <Icon name="ChevronRightIcon" size={20} className="text-muted-foreground flex-shrink-0" />
          </Link>
        ))}
      </div>

      <button className="w-full mt-4 flex items-center justify-center gap-2 px-4 py-3 bg-primary text-primary-foreground rounded-md font-medium text-sm transition-smooth hover:shadow-elevation-md hover-lift">
        <Icon name="ArrowPathIcon" size={18} />
        <span>Reorder from History</span>
      </button>
    </div>
  );
};

export default RelatedOrders;